import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { DataContext } from "../../../app/providers/DataContext";
import { CONST_DNI, CONST_KEY_USUARIO_AUTENTICADO, CONST_ROL_MASTER } from "../../../app/constants/constanst-valores";
import { usuarioCrear, usuarioEditar, usuarioObtenerCompaniasYSucursales } from "../api/usuarios.api";

// Multi Sede Usuarios: selector múltiple de sedes (mismo patrón que
// GrupoUsuariosAgregarPage). La PRIMERA sede seleccionada es la primaria
// (TMUSE10.SedCod); todas se registran en el detalle TMUSE20.
import { sedesPorCompania } from "../../sedes";
import { obtenerExtensionEImagenBase64, obtenerFechaActual, obtenerLocalStorage } from "../../../shared/utils/funciones";
import { CONST_RUTA_USUARIOS_LISTAR } from "../../../app/constants/constants-rutas-codigos";
import { sucursalesPorCompania } from "../../sucursales";
import Swal from "sweetalert2";
// DT1 (refactor por tamaño): cuerpo de campos extraído a subcomponente presentacional.
import { UsuarioFormCampos } from "../components/UsuarioFormCampos";

export const UsuarioForm = () => {

    const { listaTipoDocumento } = useContext(DataContext)

    const usuarioAutenticado = obtenerLocalStorage(CONST_KEY_USUARIO_AUTENTICADO)

    const rol = usuarioAutenticado?.tipo

    const [listaCompanias, setListaCompanias] = useState<any[]>([])
    const [listaSucursales, setListaSucursales] = useState<any[]>([])
    const [listaSedes, setListaSedes] = useState<any[]>([])

    // Multi Sede Usuarios: sedes elegidas [{value: SedCod, label: SedDesc}].
    // La primera es la sede primaria; el resto son sedes adicionales (TMUSE20).
    const [sedesSeleccionadas, setSedesSeleccionadas] = useState<any[]>([])
    const [errorSedes, setErrorSedes] = useState(false)

    const [, setMensaje] = useState('')
    const [, setMostrar] = useState(false)
    const [, setValorSeleccionado]=useState("")


    //Obtener la accion a partir de la url (agregar o editar)
    const location = useLocation();
    const pathname = location.pathname;

    const {usuario, compania,sucursal1,sede1} = location?.state || {}
    const accion = pathname.split("/").pop()
    const imagenbase = "/img/user.png"
    const { register, handleSubmit, watch, formState: { errors }, setValue } = useForm<any>({
        defaultValues: {
            usuario: usuario?.UseCod || "",
            num_ide: usuario?.UseIdeNro || "",
            nombre: usuario?.UseNom || "",
            ape_pat: usuario?.UseApePat || "",
            ape_mat: usuario?.UseApeMat || "",
            telefono: usuario?.UseTel || "",
            celular: usuario?.UseCel || "",
            sexo: usuario?.UseSex || "M",
            email_lab: usuario?.UseEmailLab || "",
            email: usuario?.UseEmail || "",
            // permiso: usuario?.UsePermi || "G",
            privilegio: usuario?.UsePriv || "N",
            fingreso: usuario?.UseFchIng || obtenerFechaActual(),
            fnacimiento: usuario?.UseFchNac || "",
            anexo: usuario?.UseAnex || "",
            ip: usuario?.UseIp || "",
            usuariokpc: usuario?.UseCod2 || "",
            clavekpc: usuario?.UsePsw2 || "",
            useridhuella: usuario?.UseIdHuell || "",
            area: usuario?.UseAre || "",
            direccion: usuario?.UseDir || "",
            ubigeo: usuario?.UseUbi || "",
            Imagen: "",
            estado: usuario?.UseEst || "A",
        },
    });

    const onSubmitCrear = async (data) => {
        // Multi Sede Usuarios: exige al menos una sede seleccionada
        if (sedesSeleccionadas.length === 0) {
            setErrorSedes(true)
            return
        }
        setErrorSedes(false)
        const imagen = await obtenerExtensionEImagenBase64(data?.Imagen[0])
        const dataPOST = {
            ...data,
            ape_pat: data?.ape_pat?.toUpperCase().trim() || "",
            ape_mat: data?.ape_mat?.toUpperCase().trim() || "",
            celular: data?.celular?.toUpperCase().trim() || "",
            compania_pad: data?.compania || "",
            compania: data?.sucursal || "",
            email_lab: data?.email_lab.trim() || "",
            email: data?.email.trim() || "",
            estado: data?.estado || "",
            nombre: data?.nombre?.toUpperCase().trim() || "",
            num_ide: data?.num_ide?.toUpperCase().trim() || "",
            privilegio: rol === CONST_ROL_MASTER ? data?.privilegio : "N",
            // Multi Sede Usuarios: la 1ra sede es la primaria (TMUSE10.SedCod);
            // `sedes` lleva la totalidad (detalle TMUSE20 en el backend).
            sede: sedesSeleccionadas?.[0]?.value || "",
            sedes: sedesSeleccionadas.map(s => s?.value),
            sexo: data?.sexo || "",
            telefono: data?.telefono?.toUpperCase().trim() || "",
            tipo_ide: data?.tipo_ide || "",
            token: usuarioAutenticado?.token,
            usuario: data?.usuario?.toUpperCase().trim() || "",
            fecha_ingreso: data?.fingreso,
            fecha_nacimiento: data?.fnacimiento,
            anexo: data?.anexo,
            ip: data?.ip,
            codigo_usuario2: data?.usuariokpc,
            password2: data?.clavekpc,
            area: data?.area,
            id_huella: data?.useridhuella,
            direccion: data?.direccion,
            ubigeo: data?.ubigeo,
            formato_foto: imagen?.Extension || "",
            foto: imagen?.imagenBase64 || "",

        }
        /*const dataIMG ={
            ...data,
            usuario: data?.usuario?.toUpperCase().trim() || "",
            foto: imagen?.imagenBase64 || "",
            num_ide: data?.num_ide?.toUpperCase().trim() || "",
            formato_foto: imagen?.Extension || "",

        }*/
        /*const dataMostrar={
            ...data,
            usuario: data?.usuario?.toUpperCase().trim() || "",
        }*/
        const { status, message } = await usuarioCrear(dataPOST)
        /*const {status1, message1} = await actualizarFoto(dataIMG)
        const{status2,message2,foto}= await mostrarFoto(dataMostrar)


        setMensaje1(message1)
        setImagenMostrar(foto)*/
        setMensaje(message)
        setMostrar(true)
        // status == 1 ? setTipoAlerta("success") : setTipoAlerta("warning")
        if (status === 1) {
            //setTipoAlerta("success")
            Swal.fire({
                title:'Se registro con exito',
                icon:'success',
                timer:2000,
                showConfirmButton:false
            })
            navigate(CONST_RUTA_USUARIOS_LISTAR, {
                state: {
                    codCompania: watch("compania"),
                    codSucursal: watch("sucursal"),
                    codSede: sedesSeleccionadas?.[0]?.value || "",
                }
            })
        } else {
            //setTipoAlerta("warning")
            // REF-ERRORES-ESPECIFICOS (2026-07-14): mostrar el motivo del backend.
            Swal.fire(
                {
                    title:'Ocurrio un error al crear el usuario',
                    text: message || '',
                    icon:'warning',
                    timer:4000,
                    showConfirmButton:false
                }
            )
        }
    }

    const onSubmitEditar = async (data) => {
        // Multi Sede Usuarios: exige al menos una sede seleccionada
        if (sedesSeleccionadas.length === 0) {
            setErrorSedes(true)
            return
        }
        setErrorSedes(false)
        const imagen = await obtenerExtensionEImagenBase64(data?.Imagen[0])
        const dataPOST = {
            ...data,
            num_ide: data?.num_ide.toUpperCase().trim() || "",
            nombre: data?.nombre.toUpperCase().trim() || "",
            ape_pat: data?.ape_pat.toUpperCase().trim() || "",
            ape_mat: data?.ape_mat.toUpperCase().trim() || "",
            telefono: data?.telefono.toUpperCase().trim() || "",
            celular: data?.celular.toUpperCase().trim() || "",
            sexo: data?.sexo || "",
            email_lab: data?.email_lab.trim() || "",
            email: data?.email.trim() || "",
            compania_pad: usuario?.UseCompPad || "",
            compania: usuario?.UseComp || "",
            // Multi Sede Usuarios: 1ra sede = primaria; `sedes` = totalidad (TMUSE20)
            sede: sedesSeleccionadas?.[0]?.value || usuario?.SedCod,
            sedes: sedesSeleccionadas.map(s => s?.value),
            fecha_ingreso: data?.fingreso,
            fecha_nacimiento: data?.fnacimiento,
            anexo: data?.anexo,
            ip: data?.ip,
            codigo_usuario2: data?.usuariokpc,
            password2: data?.clavekpc,
            area: data?.area,
            id_huella: data?.useridhuella,
            // Se crea dos atributos porque el atributo usuario es una llave primaria de la tabla usuario
            // y para actualizar una llave primaria se necesita tanto el usaurio anterior y el nuevo usuario actualizado
            usuario: usuario?.UseCod || "",
            usuario_nuevo: data?.usuario?.toUpperCase() || "",
            direccion: data?.direccion,
            ubigeo: data?.ubigeo,
            formato_foto: imagen?.Extension,
            foto: imagen?.imagenBase64,
            token: usuarioAutenticado?.token


        }
        //console.log(dataPOST)
        const { status, message } = await usuarioEditar(dataPOST)
        setMostrar(true)
        setMensaje(message)

        //status == 1 ? setTipoAlerta("success") : setTipoAlerta("warning")
        if (status === 1){
            Swal.fire({
                title:'Se actualizo correctamente los datos',
                icon:'success',
                timer:2000,
                showConfirmButton:false
            })
        }else{
            // REF-ERRORES-ESPECIFICOS (2026-07-14): mostrar el motivo del backend.
            Swal.fire(
                {
                    title:'Ocurrio un error al actualizar los datos',
                    text: message || '',
                    icon:'warning',
                    timer:4000,
                    showConfirmButton:false
                }
            )
        }

    }

    const navigate = useNavigate();

    const cancelar = () => {
        if(accion === "agregar"){
            navigate(CONST_RUTA_USUARIOS_LISTAR, {
                state: {
                    codCompania: watch("compania"),
                    codSucursal: sucursal1,
                    codSede: sede1,
                }
            })
        }else{
            navigate(CONST_RUTA_USUARIOS_LISTAR, {
                state: {
                    codCompania: watch("compania"),
                    codSucursal: watch("sucursal"),
                    codSede: sedesSeleccionadas?.[0]?.value || "",
                }
            })
        }

    }

    // token?: acepta (e ignora) el argumento que pasa cargarDatosIniciales;
    // el valor real se lee del closure `usuarioAutenticado`. Runtime sin cambios.
    const obtenerCompaniasYSucursales = async (token?: any) => {

        const dataPOST = {
            token: usuarioAutenticado?.token
        }

        const { companias, sucursales, sedes } = await usuarioObtenerCompaniasYSucursales(dataPOST)
        setListaCompanias(companias)
        setListaSucursales(sucursales)
        //setValue("compania", usuario?.UseCompPad || companias?.[0]?.id)
        setValue("compania", usuario?.UseCompPad || compania)

        return {
            companias:compania,
            sucursales:sucursales,
            sedes:sedes
        }
    }

    const obtenerSucursalesPorCompania = async (idCompania) => {

        if (idCompania) {
            const dataPOST = {
                token: usuarioAutenticado?.token,
                Codigo: idCompania,
                Estado: "A"
            }
            const { sucursales } = await sucursalesPorCompania(dataPOST)
            //console.log(sucursales)
            setListaSucursales(sucursales)
            //setValue("sucursal", usuario?.UseComp || sucursales?.[0]?.CompCod)
            setValue("sucursal", usuario?.UseComp || "")


        }
    }

    // Multi Sede Usuarios: selección inicial en EDICIÓN — detalle `usuario.sedes`
    // (TMUSE20, lo devuelve MostrarUsuario) o, si no existe aún, la sede única
    // legacy `usuario.SedCod`.
    const construirSeleccionInicial = (sedes) => {
        // Toma la etiqueta de la opción del árbol (incluye "SUCURSAL — SEDE") si existe;
        // si no, cae a la descripción del detalle o un genérico.
        const etiqueta = (cod, fallback) => {
            const opt = sedes?.find(e => String(e?.SedCod) === String(cod))
            return opt?.SedDesc || fallback
        }
        if (Array.isArray(usuario?.sedes) && usuario.sedes.length > 0) {
            return usuario.sedes.map(s => ({
                value: s?.SedCod,
                label: etiqueta(s?.SedCod, s?.SedDesc || `Sede ${s?.SedCod}`)
            }))
        }
        if (usuario?.SedCod) {
            return [{ value: usuario.SedCod, label: etiqueta(usuario.SedCod, `Sede ${usuario.SedCod}`) }]
        }
        return []
    }

    // MULTI-SEDE ÁRBOL (2026-09-01): el picker carga TODAS las sedes del ÁRBOL de la
    // compañía padre (todas las sub-compañías), etiquetadas por sucursal, para poder
    // configurar usuarios que ven sedes de VARIAS sub-compañías (multi-vista). El
    // parámetro ya no acota la fuente (que es el árbol); solo indica si se precarga la
    // selección del usuario (carga inicial de EDITAR). Al cambiar de sucursal NO se
    // limpia la selección (el árbol es el mismo → se conserva lo ya elegido).
    const obtenerSedesPorSucursal = async (_idSucursal, precargarSeleccion = false) => {
        const compPadre = watch("compania") || usuario?.UseCompPad

        if (compPadre) {
            const dataPOST = {
                compania: 'T',
                comp_pad: compPadre,
                token: usuarioAutenticado?.token
            }
            const { sedes } = await sedesPorCompania(dataPOST)

            // "SUCURSAL — SEDE": distingue sedes homónimas de distintas sub-compañías.
            const opciones = (sedes || []).map(s => ({
                ...s,
                SedDesc: s?.sucursal_nom ? `${s.sucursal_nom} — ${s?.SedDesc}` : s?.SedDesc
            }))
            setListaSedes(opciones)
            if (precargarSeleccion) setSedesSeleccionadas(construirSeleccionInicial(opciones))
        } else {
            setSedesSeleccionadas([])
            setListaSedes([])
        }
    }

    const [maxLengthInput, setMaxLengthInput] = useState(8)

    const handleInputChange = (e) => {
        let inputValue = e.target.value.trim(); // Eliminar espacios en blanco al inicio y al final

        if (watch("tipo_ide") === "D") {
            // Filtrar caracteres no numéricos cuando tipo_ide es "D"
            inputValue = inputValue.replace(/[^0-9]/g, "");
        }

        // Limitar la longitud del valor (sin contar espacios)
        if (inputValue.length > maxLengthInput) {
            inputValue = inputValue.slice(0, maxLengthInput);
        }

        e.target.value = inputValue;
    };

    const cambiarTipoDocumento = () => {
        if (watch("tipo_ide") === "D") {
            setMaxLengthInput(8)
        } else {
            setMaxLengthInput(12)
        }
    }

    useEffect(() => {

        const cargarDatosIniciales = async () => {

            const { sucursales, sedes } = await obtenerCompaniasYSucursales(usuarioAutenticado?.token)

            if (rol === CONST_ROL_MASTER) {

                await obtenerSucursalesPorCompania(watch("compania"));
                await obtenerSedesPorSucursal(watch("sucursal"), accion === "editar");
            } else {
                const listaSucursalesFormateada = sucursales?.map(s => ({
                    CompCod: s?.id,
                    CompNom: s?.tipo
                }))

                setListaSucursales(listaSucursalesFormateada)
                if(accion === "editar"){

                    setValorSeleccionado(usuario.UseComp)
                    setValue("sucursal", usuario?.UseComp)
                }else{
                    setValorSeleccionado("disabled")
                    setValue("sucursal", "")
                }
                //setValue("sucursal", listaSucursalesFormateada?.[0]?.CompCod)
            }
            if (sucursales?.length > 1) {

                await obtenerSedesPorSucursal(watch("sucursal"), accion === "editar");
            } else {

                const listaSedesFormateada = sedes?.map(s => ({
                    SedCod: s?.id,
                    SedDesc: s?.tipo
                }))
                setListaSedes(listaSedesFormateada)
                if(accion === "editar"){
                    // Multi Sede Usuarios: precarga el detalle (o la sede única legacy)
                    setSedesSeleccionadas(construirSeleccionInicial(listaSedesFormateada))
                }
            }

        };

        cargarDatosIniciales();
        setValue("tipo_ide", usuario?.UseTIde || CONST_DNI);
        // carga inicial (una sola vez al montar)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="p-3">
            <div className="container-fluid">
                <h3 className="tw-text-center tw-text-2xl tw-font-semibold tw-text-menu-primario tw-mt-1 tw-mb-4">Usuario</h3>
                <div className="row mt-3">
                    <div className="col-12 col-lg-9 mx-auto mt-0">
                        {/* Formulario */}

                        <form id="CreateForm" onSubmit={accion === "agregar" ? handleSubmit(onSubmitCrear) : handleSubmit(onSubmitEditar)} className="row g-2 p-1">

                            <UsuarioFormCampos
                                accion={accion}
                                imagenbase={imagenbase}
                                handleSubmit={handleSubmit}
                                onSubmitCrear={onSubmitCrear}
                                onSubmitEditar={onSubmitEditar}
                                register={register}
                                errors={errors}
                                watch={watch}
                                listaCompanias={listaCompanias}
                                listaSucursales={listaSucursales}
                                listaSedes={listaSedes}
                                listaTipoDocumento={listaTipoDocumento}
                                sedesSeleccionadas={sedesSeleccionadas}
                                setSedesSeleccionadas={setSedesSeleccionadas}
                                errorSedes={errorSedes}
                                setErrorSedes={setErrorSedes}
                                obtenerSucursalesPorCompania={obtenerSucursalesPorCompania}
                                obtenerSedesPorSucursal={obtenerSedesPorSucursal}
                                cambiarTipoDocumento={cambiarTipoDocumento}
                                handleInputChange={handleInputChange}
                                maxLengthInput={maxLengthInput}
                                rol={rol}
                            />
                        </form>


                        <div className='mt-4 botones-accion text-center'>
                            {
                                accion === "agregar" && (
                                    <button className='btn btn-sm btn-primario col-md-2' type="submit" form="CreateForm" onClick={handleSubmit(onSubmitCrear)}>Guardar</button>
                                )
                            }
                            {
                                accion === "editar" && (
                                    <button className='btn btn-sm btn-primario col-md-2' type="submit" form="CreateForm" onClick={handleSubmit(onSubmitEditar)}>Guardar</button>
                                )
                            }
                            <button className='btn btn-sm btn-secundario col-md-2' onClick={cancelar}>Cancelar</button>

                        </div>
                        {/* Fin formulario */}
                    </div >

                </div>

                {/*
                    mostrar && (
                        <div className="row mt-4">
                            <div className="col-lg-6 mx-auto text-center alert-error">
                                <Stack spacing={2}>
                                    <Alert variant="outlined" severity={tipoAlerta} >{mensaje}</Alert>
                                </Stack>
                            </div>
                        </div>

                    )
                */}

            </div>
        </div>
    )
}
